import { createContext } from 'react';

/**
 * Padding scale a container asks its slots to use, so a card's header, content
 * and footer share one inset without each call site restating it. Internal:
 * containers provide it, slots consume it, product code never sets it.
 */
export type SlotPadding = 'none' | 'compact' | 'default' | 'spacious';

export type SlotStyle = {
  padding?: SlotPadding;
};

export const SlotStyleContext = createContext<SlotStyle>({});
